// extracted by mini-css-extract-plugin
export default {"statsBar":"StatsBar_statsBar__rcAtD"};